module.exports = __webpack_public_path__ + "static/media/screenshot-9.8ea49855.png";